<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [url]="url"
  [columns]="columns"
  [filters]="filters"
  (onActionButtonClick)="actionButtonClick($event.actionType, $event.row)"
  [columnWidths]="columnWidths"
  [type]="'patienList'"
  [signalModel]="signalrModel"
></app-tables>